import i18n from '../../../i18n';

export const t = (value) => {
    if (typeof value !== 'string' || !value) return value;
    const key = value.trim();
    return value.replace(
        key,
        i18n.t(key, {
            ns: 'selfProfile',
            keySeparator: false,
            nsSeparator: false,
            defaultValue: key
        })
    );
};
export default i18n;
